// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum TimeOfDay {
	Unknown = 0,
	Day = 1,
	Night = 2,
	Dusk = 3,
	Dawn = 4,
}

export const TimeOfDayDisplayNames: { [key in keyof typeof TimeOfDay]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"Day": "Day",
	1 : "Day",
	"Night": "Night",
	2 : "Night",
	"Dusk": "Dusk",
	3 : "Dusk",
	"Dawn": "Dawn",
	4 : "Dawn",
}

export const getTimeOfDayDisplayName = (key: TimeOfDay | (keyof typeof TimeOfDay & string)) => {
	return TimeOfDayDisplayNames[key];
}

